
export enum VehicleRemark {
  MILEAGE_UNCERTAIN_TRUST_REPORT= 'MILEAGE_UNCERTAIN_TRUST_REPORT',
  MILEAGE_UNCERTAIN_LAST_INSPECTION= 'MILEAGE_UNCERTAIN_LAST_INSPECTION',
  E5EEV_PARTICULATE_CLASSIFICATION= 'E5EEV_PARTICULATE_CLASSIFICATION',
  CNG_DUAL_FUEL_SYSTEM= 'CNG_DUAL_FUEL_SYSTEM',
  CNG_CYLINDER_INSPECTION_BUYER_EXPENSE= 'CNG_CYLINDER_INSPECTION_BUYER_EXPENSE',
  MORTGAGE_EXPIRED_ENFORCEABILITY= 'MORTGAGE_EXPIRED_ENFORCEABILITY',
  SPAIN_INDIVIDUAL_APPROVAL_PRE_2012= 'SPAIN_INDIVIDUAL_APPROVAL_PRE_2012',
  ITALY_FOREIGN_DOCS_NATIONALIZATION= 'ITALY_FOREIGN_DOCS_NATIONALIZATION',
  ITALY_INSPECTION_EXPIRED_EXPORT= 'ITALY_INSPECTION_EXPIRED_EXPORT',
  DELIVERY_DELAY_LEASING_15_DAYS= 'DELIVERY_DELAY_LEASING_15_DAYS',
  DELIVERY_DELAY_10_DAYS= 'DELIVERY_DELAY_10_DAYS',
  DELIVERY_DELAY_20_DAYS= 'DELIVERY_DELAY_20_DAYS',
  DELIVERY_DELAY_30_DAYS= 'DELIVERY_DELAY_30_DAYS',
  DELIVERY_DELAY_45_DAYS= 'DELIVERY_DELAY_45_DAYS',
  DELIVERY_DELAY_60_DAYS= 'DELIVERY_DELAY_60_DAYS',
  DISMANTLING_TECHNICAL_FLUIDS_PRESENT= 'DISMANTLING_TECHNICAL_FLUIDS_PRESENT',
  DISMANTLING_FLUIDS_AND_CNG_PRESENT= 'DISMANTLING_FLUIDS_AND_CNG_PRESENT',
  BRANDING_OBSCURED_FOR_PRIVACY= 'BRANDING_OBSCURED_FOR_PRIVACY',

}